import { motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";
import { Stagger, staggerItem } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { useSeo } from "@/lib/seo";
import { useBrand } from "@/context/SiteContext";
import { PROJECT_CATEGORIES } from "@/data/content";

export default function Projects() {
  const brand = useBrand();
  useSeo({ title: `Projects | ${brand.name}`, description: `Residential, commercial, industrial, institutional, government and B2B solar, storage and power projects by ${brand.name}.`, canonical: `https://${brand.domain}/projects` });
  return (
    <div>
      <PageHeader label="Projects" title="Solutions Delivered Across Sectors" sub="Explore the categories of projects and supply we support. Detailed project case studies are published as verified information becomes available." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROJECT_CATEGORIES.map((p) => (
            <motion.div key={p.title} variants={staggerItem} className="card-surface p-7">
              <div className="font-display font-semibold text-white text-xl">{p.title}</div>
              <p className="text-sm text-slate-400 mt-2 leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </Stagger>
        <div className="mt-12 card-surface p-8 text-center">
          <div className="mono-label">Project Case Studies</div>
          <h2 className="font-display text-2xl font-bold text-white mt-2">Detailed projects coming soon</h2>
          <p className="text-slate-400 mt-2 max-w-xl mx-auto">Individual projects — with location, capacity, system type, scope and images — are displayed only after actual information is confirmed. No project statistics are fabricated.</p>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
